export default __webpack_public_path__ + "static/media/Benton-Sans-Wide-Black-Italic.dedd87c2.otf";